import * as React from 'react';

import { requestPost } from '../../../../modules/request/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';
import { ButtonSpinner } from '../../../Shared';
import DemoGuardedButton from '../shared/demoGuardedButton';

interface ArchiveClassModalProps {
  close: () => void;
  onSuccess: (string) => void;
  classroom: any;
}

export const ArchiveClassModal = ({ classroom, close, onSuccess }: ArchiveClassModalProps) => {
  const { modalRef } = useModalAccessibility(close);

  const [processingRequest, setProcessingRequest] = React.useState<boolean>(false)

  const supportLink = <a className="focus-on-light" href="https://support.quill.org/getting-started-for-teachers/manage-classes/how-can-i-manage-my-classes-and-student-profiles" target="_blank">Learn more</a>  //eslint-disable-line react/jsx-no-target-blank

  function handleArchiveClassButtonClick() {
    setProcessingRequest(true)
    requestPost(`/teachers/classrooms/${classroom.id}/hide`, null, () => {
      onSuccess('Class archived')
      setProcessingRequest(false)
    })
  }

  return (
    <div className="modal-container archive-class-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="archiveClassModalTitle"
        aria-modal="true"
        className="archive-class-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="archiveClassModalTitle">Archive this class?</h3>
        </div>
        <div className="archive-class-modal-text">
          <p>If you archive the class {classroom.name}, students in this class will no longer be able to access activities. You can view this class in &#34;Archived Classes&#34; under the &#34;Classes&#34; tab.</p>
          {supportLink}
        </div>
        <div className="form-buttons">
          <button className="quill-button outlined green medium focus-on-light" onClick={close} type="button">Cancel</button>
          <DemoGuardedButton className="quill-button contained green medium archive-button focus-on-light" onClick={handleArchiveClassButtonClick}>{processingRequest ? <ButtonSpinner variant="light" /> : 'Archive'}</DemoGuardedButton>
        </div>
      </div>
    </div>
  )
}

export default ArchiveClassModal
